export default function PlantationHeroSection() {
  return (
    <section className="relative min-h-[560px] md:min-h-[640px] flex items-center justify-center overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Lush%20green%20suburban%20Florida%20neighborhood%20with%20Jacaranda%20trees%20in%20bloom%2C%20wide%20residential%20streets%2C%20manicured%20lawns%2C%20warm%20golden%20afternoon%20light%2C%20Mediterranean%20and%20ranch%20style%20homes%2C%20peaceful%20community%20atmosphere%2C%20high%20quality%20architectural%20photography&width=1600&height=900&seq=plantation-hero&orientation=landscape"
          alt="Plantation Florida suburban neighborhood with Jacaranda trees"
          className="w-full h-full object-cover object-top"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 md:px-8 text-center py-20">
        <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-4 py-1.5 mb-6">
          <i className="ri-map-pin-2-line text-[#F6C344] text-sm"></i>
          <span className="text-white/80 text-xs font-semibold uppercase tracking-wider">Broward County, Florida</span>
        </div>

        <h1 className="font-serif text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
          Expedited Passport Services in Plantation, FL
        </h1>

        <p className="text-white/80 text-base md:text-lg max-w-2xl mx-auto mb-8 leading-relaxed">
          Emergency and same-day passport processing for Plantation travelers. Serving Broward County&apos;s &quot;City of Trees&quot; — from Jacaranda-lined neighborhoods to Sawgrass Mills, with courier pickup and overnight document shipping.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-10">
          <a
            href="https://fastpassportcenter.com/checkout/"
            className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-base px-8 py-4 rounded-md transition-all hover:scale-105 whitespace-nowrap"
          >
            Start Your Passport <i className="ri-arrow-right-line"></i>
          </a>
          <a
            href="#how-it-works"
            className="inline-flex items-center gap-2 bg-white/10 hover:bg-white/20 backdrop-blur-sm border border-white/30 text-white font-semibold text-base px-8 py-4 rounded-md transition-all whitespace-nowrap"
          >
            <i className="ri-time-line"></i> See Processing Options
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-white/60 text-xs">
          <span className="flex items-center gap-1.5"><i className="ri-shield-check-line text-[#F6C344]"></i> Registered State Dept. Courier</span>
          <span className="flex items-center gap-1.5"><i className="ri-award-line text-[#F6C344]"></i> A+ BBB Rated</span>
          <span className="flex items-center gap-1.5"><i className="ri-flashlight-line text-[#F6C344]"></i> As Fast as 24 Hours</span>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10">
        <a href="#processing-options" className="flex flex-col items-center gap-1 text-white/50 hover:text-white transition-colors">
          <span className="text-[10px] uppercase tracking-widest font-medium">Scroll</span>
          <i className="ri-arrow-down-line text-lg animate-bounce"></i>
        </a>
      </div>
    </section>
  );
}